module.exports = __webpack_public_path__ + "img/09.cbed7d0e.jpg";